import { NavHeaderTheme } from "./types";

export const defaultTheme: NavHeaderTheme = {
  container: "fixed top-0 left-0 right-0 z-10 bg-white p-4 pb-6",
  text: "text-current text-base font-normal text-center",
  button: "p-1",
  spacer: "w-8",
  subtitleContainer: "w-full text-center",
  subtitleText: "text-current text-sm",
};
